export default __webpack_public_path__ + "static/media/t1.c49915b4.png";